import type { ReactNode } from "react";
import { Link } from "react-router";
import styles from "./AdminPage.module.css";

interface AdminPageProps {
  readonly title: string;
  readonly showBack?: boolean;
  readonly aside?: ReactNode;
  readonly children: ReactNode;
}

export function AdminPage({ title, showBack = true, aside, children }: AdminPageProps) {
  return (
    <div className={styles.page}>
      <div className={styles.header}>
        {showBack ? <Link to="/admin" className={styles.back}>← Admin</Link> : null}
        <h1 className={styles.title}>{title}</h1>
        {aside ? <div className={styles.muted}>{aside}</div> : null}
      </div>
      {children}
    </div>
  );
}
